import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/jb-time/jb-time.css.ts
var jb_time_css_default = i`*,*::before,*::after{box-sizing:border-box}*:focus-visible{outline-color:rgb(var(--theme-color-signal-blue, 0 37 255));outline-offset:6px;outline-style:var(--focus-outline-style, auto)}div,object,iframe,h1,h2,h3,h4,h5,h6,p,blockquote,ol,ul,li,form,legend,label,table,header,footer,nav,section,figure{margin:0;padding:0}a{color:inherit}time{font-family:var(--theme-font-bold-family, VerlagSSm, Tahoma, sans-serif);font-weight:var(--theme-font-bold-weight, 700)}:host{color:var(--host-color, #141e55)}:host{--jb-clock-opacity: 1}time{align-items:center;color:#141e55;display:flex;text-transform:uppercase;font-size:11px;font-size:0.6875rem;line-height:16px;line-height:1rem}time jb-clock-icon{display:inline-flex;margin-right:10px;width:16px}@media(max-width: 959px){time{position:relative}}`;

export {
  jb_time_css_default
};
